/**
 * Parse a Roll20/Foundry-style HP edit input into an absolute or relative
 * change (issue #135).
 *
 *  - A bare number  ("12")  → `{ set: 12 }`   (absolute)
 *  - A signed number ("+5") → `{ delta: 5 }`  (relative)
 *  - A signed number ("-3") → `{ delta: -3 }` (relative)
 *  - Empty / non-numeric    → `null`          (caller treats as a no-op)
 *
 * Shared by the selected-token HUD HP bar and the on-canvas HP-bar popover so
 * both interpret keystrokes identically.
 */
export function parseHpEditInput(
  raw: string,
): { set: number } | { delta: number } | null {
  const s = raw.trim()
  if (!s) return null
  const relative = s[0] === '+' || s[0] === '-'
  const n = parseInt(s, 10)
  if (Number.isNaN(n)) return null
  return relative ? { delta: n } : { set: n }
}
